import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getWebsiteAuditWhen(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Původní dodavatel neplní sliby",
			desc: "Investovali jste do vývoje stránek velké peníze, ale teď vám web dělá vrásky na čele a je zřejmé, že váš původní dodavatel nesplnil, co slíbil? Napravíme to.",
		},
		{
			title: "Řešíte pomalé načítání a další technické potíže",
			desc: "Rychlost načítání ovlivňuje uživatelskou zkušenost i SEO. Audit pomůže identifikovat technické problémy, které pak můžeme v rámci optimalizace vyřešit.",
		},
		{
			title: "Máte nízkou návštěvnost stránek",
			desc: "Když na stránky navzdory očekáváním nechodí dostatek návštěvníků, může být problém například v technických záležitostech webu.",
		},
		{
			title: "Evidujete málo poptávek",
			desc: "Za nižším počtem poptávek nebo jiných konverzí bývají kromě technických nedostatků i nedokonalosti z hlediska uživatelské zkušenosti s webem (tzv. UX).",
		},
		{
			title: "Web není optimalizovaný pro mobily",
			desc: "V dnešní době je klíčové, aby web správně vypadal i fungoval i na mobilních zařízení. Jen tak bude přinášet ovoce a zakázky.",
		},
		{
			title: "PPC reklamy nefungují, jak mají",
			desc: "Pokud placené kampaně negenerují očekávané výsledky, audit vám pomůže zjistit, zda je problém na straně webu.",
		},
	];
}
